import { render } from "./ShowJudgeBestInShow.vue?vue&type=template&id=36c0ba27"
import script from "./ShowJudgeBestInShow.vue?vue&type=script&lang=ts"
export * from "./ShowJudgeBestInShow.vue?vue&type=script&lang=ts"
script.render = render

export default script